import { Fragment, ReactElement, ReactNode } from 'react';
import BgNsTimeline from '@britishgasenergy/react-nucleus/dist/nuc-components/NsTimeline';
import { NsTimelineEvent } from './NsTimelineEvent';

type NsTimelineProps = {
  children:
    | ReactElement<typeof NsTimelineEvent>
    | ReactElement<typeof NsTimelineEvent>[]
    | ReactElement<typeof Fragment>
    | ReactElement<typeof Fragment>[];
  heading?: string;
  summary?: ReactNode;
  showStepCount?: boolean;
  type?: 'standard' | 'step';
  testId?: string;
};

export const NsTimeline = ({
  heading,
  summary,
  showStepCount,
  type = 'step',
  testId,
  children
}: NsTimelineProps) => {
  return (
    <BgNsTimeline
      type={type}
      showStepCount={showStepCount}
      role="list"
      data-testid={testId}
    >
      <h3 slot="heading">{heading}</h3>
      {summary && <p slot="summary">{summary}</p>}
      {children}
    </BgNsTimeline>
  );
};
